import { useQuery } from "react-query";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import "./examcomplete.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint, formatResultsData } from "../components/utils";
import { pageIds } from "../components/utils";
import { AppDataContext, ctxDefinition } from "../components/ctx";
import { BrandButton } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import NetworkError from "../components/networkError";
import { ExamResultsToHTML } from "../components/data2html";
import { renderToString } from "react-dom/server";

interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
}

const ExamComplete = () => {
  const navigate = useNavigate();
  const emailSent = useRef(false);
  const { userData, setUserData, setExamStarted } = useContext(
    AppDataContext
  ) as ctxDefinition;
  const [data, setdata] = useState<PageResponse | null>();
  const [hasError, setHasError] = useState(false);
  const { isLoading, error } = useQuery("examResultsPageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/firstchoiceprep/v1/getPageText?slug=" +
        pageIds.exam_complete
    );
    setdata(resp.data as PageResponse);

    const respResult = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/snapShot",
      {
        token: userData.token,
      }
    );

    const resp2 = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/testResults",
      {
        token: userData.token,
        userID: userData.userid,
      }
    );
  if (!resp2 || !resp2.data.success || !respResult || !respResult.data.success) {
      setHasError(true);
      return;
    } else { 
      const stats = formatResultsData(resp2.data);
      const html = renderToString(ExamResultsToHTML(stats));
      sendExamEndEmail(html);  
    }        
  });                 

  const updateServerProfile = async () => {
    const resp = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["examComplete", "examCompleteTime"],
        values: [true, new Date().getTime() / 1000],
      }
    );
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }
  };
 
  const sendExamEndEmail = async (html: any) => {
    if(emailSent.current === true) return;
    await axios.post(ApiEndpoint + "wp-json/firstchoiceprep/v1/sendEmail", {
      token: userData.token,
      output: html,
    });
    emailSent.current = true;  
  }; 

  useEffect(() => {
    const temp = { ...userData };
    temp.examComplete = true;
    temp.sectionStartTime = null;
    temp.examStarted = false;
    setUserData(temp);
    setExamStarted(false);
    updateServerProfile();
 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="examCompletePage">
      <div className="headline">
        <h1>{data?.headerTitle}</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }}
        />
        <div className="btnHolder">
          <BrandButton
            onClick={() => navigate("/exam-results", { replace: true })}
          >
            VIEW YOUR RESULTS
          </BrandButton>
        </div>
      </div>
      <NetworkError open={hasError} />
    </div>
  );
};

export default ExamComplete;
